export default __webpack_public_path__ + "static/media/rock7.f95189ba.jpg";